export default __webpack_public_path__ + "static/montserrat-v15-latin-700italic-c41ad6bdb4bd504a843d546d0a47958d.woff2";